/**
 * Type guards for question verification.
 * These utilities help with type-safe access to verification properties
 * across different question types.
 */

// Interfaces for the expected shapes
export interface WithFormVerification {
  formVerification: {
    id: string;
    is_avela_ai_assisted?: boolean;
    is_identity_ai_assisted?: boolean;
  };
}

export interface WithNewFormVerification {
  newFormVerification: {
    label: string;
    is_avela_ai_assisted: boolean;
    is_identity_ai_assisted: boolean;
  };
}

export interface WithFormQuestion {
  form_question: {
    form_verification?: {
      id: string;
      is_avela_ai_assisted?: boolean;
      is_identity_ai_assisted?: boolean;
    };
  };
}

/**
 * Type guard to check if an object has a valid formVerification property
 */
export function hasValidFormVerification(
  obj: any
): obj is WithFormVerification {
  return (
    obj &&
    typeof obj === "object" &&
    "formVerification" in obj &&
    obj.formVerification &&
    typeof obj.formVerification === "object" &&
    "id" in obj.formVerification &&
    obj.formVerification.id !== "NEW"
  );
}

/**
 * Type guard to check if an object has a valid newFormVerification property
 */
export function hasValidNewFormVerification(
  obj: any
): obj is WithNewFormVerification {
  return (
    obj &&
    typeof obj === "object" &&
    "newFormVerification" in obj &&
    obj.newFormVerification &&
    typeof obj.newFormVerification === "object" &&
    "is_avela_ai_assisted" in obj.newFormVerification &&
    "is_identity_ai_assisted" in obj.newFormVerification
  );
}

/**
 * Type guard to check if an object has a valid form_question with form_verification
 */
export function hasValidFormQuestionVerification(
  obj: any
): obj is WithFormQuestion {
  return (
    obj &&
    typeof obj === "object" &&
    "form_question" in obj &&
    obj.form_question &&
    typeof obj.form_question === "object" &&
    "form_verification" in obj.form_question &&
    obj.form_question.form_verification &&
    typeof obj.form_question.form_verification === "object" &&
    "id" in obj.form_question.form_verification
  );
}
